<template>
  <main>


    <!-- Navigation -->
    <div class="container-fluid space-top-md-1 space-bottom-2 space-bottom-lg-3">


      <!-- Tableau de navigation -->
      <article class="container-fluid card py-4 h-100">
        <div class="row no-gutters">

          <!-- 1 Filtres -->
          <div class="col-2 card shadow-none d-flex mx-0 pr-1 border-right" style="border-radius: 0px;">

            <!-- Accessiblité -->
            <span class="mr-3">
              <a class="btn btn-xs btn-primary btn-pill" href="javascript:;"
                 data-toggle="tooltip" data-placement="top" title="Déficience moteur">
                <i class="fa fa-wheelchair"></i>
              </a>
              <a class="btn btn-xs btn-primary btn-pill" href="javascript:;"
                 data-toggle="tooltip" data-placement="top" title="Déficience auditive">
                <i class="fa fa-deaf"></i>
              </a>
              <a class="btn btn-xs btn-primary btn-pill" href="javascript:;"
                 data-toggle="tooltip" data-placement="top" title="Déficience visuelle">
                <i class="fa fa-low-vision"></i>
              </a>
              <a class="btn btn-xs btn-primary btn-pill" href="javascript:;"
                 data-toggle="tooltip" data-placement="top" title="Déficience mentale">
                <i class="fa fa-head-side-heart"></i>
              </a>
            </span>
            <!-- Fin Accessiblité -->


            <!-- Ressources -->
            <!-- Fin Ressources -->

            <!-- Je trouve -->
            <span>
              <div class="collapse" id="collapseTrouver">
                  <a class="btn btn-xs btn-soft-success btn-pill mx-sm-1 mb-2 text-md-left float-left"
                     href="javascript:;">Bénévoles</a>
              </div>
              <div class="collapse" id="collapseTrouver">
                <a class="btn btn-xs btn-soft-success btn-pill mx-sm-1 mb-2 text-md-left float-left"
                   href="javascript:;">Matériel</a>
              </div>
              <div class="collapse" id="collapseTrouver">
                <a class="btn btn-xs btn-soft-success btn-pill mx-sm-1 mb-2 text-md-left float-left"
                   href="javascript:;">Locaux</a>
              </div>
              <div class="collapse" id="collapseTrouver">
                <a class="btn btn-xs btn-soft-success btn-pill mx-sm-1 mb-2 text-md-left float-left"
                   href="javascript:;">Expertise</a>
              </div>
            </span>
            <!-- Fin Je trouve -->

            <!-- J'aide -->
            <span>
              <div class="collapse" id="collapseAider">
                  <a class="btn btn-xs btn-soft-dark btn-pill mx-sm-1 mb-2 float-right"
                     href="javascript:;">Bénévoles</a>
              </div>
              <div class="collapse" id="collapseAider">
                <a class="btn btn-xs btn-soft-dark btn-pill mx-sm-1 mb-2 float-right" href="javascript:;">Matériel</a>
              </div>
              <div class="collapse" id="collapseAider">
                <a class="btn btn-xs btn-soft-dark btn-pill mx-sm-1 mb-2 float-right" href="javascript:;">Locaux</a>
              </div>
              <div class="collapse" id="collapseAider">
                <a class="btn btn-xs btn-soft-dark btn-pill mx-sm-1 mb-2 float-right" href="javascript:;">Expertise</a>
              </div>
            </span>
            <!-- Fin J'aide -->


            <!-- Axes -->
            <!-- Fin Axes -->

            <!-- Thèmes -->
            <span>
                          <!-- Collapse Categorie -->
            <div class="container pl-0 pr-3">
              <div class="row mb-2 mt-3">
                <div class="col">
                  Catégories:
                </div>
              </div>

              <!-- Card -->
              <div class="card card-bordered overflow-hidden mb-1">
                <!-- 1 partager -->
                <div class="card-header card-collapse" id="catHeadingApprendre">
                  <a class="btn btn-link btn-sm btn-block card-btn" href="javascript:;" role="button"
                     data-toggle="collapse" data-target="#catCollapseApprendre"
                     aria-expanded="false" aria-controls="catCollapseApprendre">
                    <!-- Header -->
                    <span class="row">
                      <span class="col-8">
                        <span class="media">
                          <span class="card-btn-toggle mr-3 ml-0">
                            <span class="card-btn-toggle-default">+</span>
                            <span class="card-btn-toggle-active">−</span>
                          </span>
                          <span class="media-body">
                            <span class="text-body font-weight-bold mr-5">Apprendre, Partager</span>
                          </span>
                        </span>
                      </span>
                    </span>
                    <!-- End Header -->
                  </a>
                </div>
                <div id="catCollapseApprendre" class="collapse" aria-labelledby="catHeadingApprendre">
                  <div class="card-body p-0">


                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeApprentissage" class="custom-control-input"
                                     value="Apprentissage" v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeApprentissage">Apprentissages</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeLoisirs" class="custom-control-input"
                                     value="Loisirs creatifs" v-model="checked_filters">
                              <label class="custom-control-label font-size-1"
                                     for="customAxeLoisirs">Loisirs créatifs</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeArtSport" class="custom-control-input"
                                     value="Art & Sport" v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeArtSport">Pratiques artistiques et sportives</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeSante" class="custom-control-input" value="Sante"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1"
                                     for="customAxeSante">Santé / Bien-être</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeExprimer" class="custom-control-input"
                                     value="Exprimer" v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeExprimer">S'exprimer, Echanger, Agir</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->


                  </div>
                </div>

                <!-- 2 informer -->
                <div class="card-header card-collapse" id="catHeadingInformer">
                  <a class="btn btn-link btn-sm btn-block card-btn" href="javascript:;" role="button"
                     data-toggle="collapse" data-target="#catCollapseInformer"
                     aria-expanded="false" aria-controls="catCollapseInformer">
                    <!-- Header -->
                    <span class="row">
                      <span class="col-8">
                        <span class="media">
                          <span class="card-btn-toggle mr-3 ml-0">
                            <span class="card-btn-toggle-default">+</span>
                            <span class="card-btn-toggle-active">−</span>
                          </span>
                          <span class="media-body">
                            <span class="text-body font-weight-bold mr-5">Informer, Orienter, Accompagner</span>
                          </span>
                        </span>
                      </span>
                    </span>
                    <!-- End Header -->
                  </a>
                </div>
                <div id="catCollapseInformer" class="collapse" aria-labelledby="catHeadingInformer">
                  <div class="card-body p-0">


                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeAccompagnementIndividuel" class="custom-control-input"
                                     value="Accompagnement" v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeAccompagnementIndividuel">Accompagnement individuel / Services de proximité</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeFamille" class="custom-control-input" value="Famille"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeFamille">Accompagnement des familles</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeSeniors" class="custom-control-input" value="Seniors"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeSeniors">Accompagnement des seniors</label>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <!-- End Course Program -->

                  </div>

                </div>

                <!-- 3 quartier -->
                <div class="card-header card-collapse" id="catHeadingQuartier">
                  <a class="btn btn-link btn-sm btn-block card-btn" href="javascript:;" role="button"
                     data-toggle="collapse" data-target="#catCollapseQuartier"
                     aria-expanded="false" aria-controls="catCollapseQuartier">
                    <!-- Header -->
                    <span class="row">
                      <span class="col-8">
                        <span class="media">
                          <span class="card-btn-toggle mr-3 ml-0">
                            <span class="card-btn-toggle-default">+</span>
                            <span class="card-btn-toggle-active">−</span>
                          </span>
                          <span class="media-body">
                            <span class="text-body font-weight-bold mr-5">Vivre dans son quartier, S'entraider</span>
                          </span>
                        </span>
                      </span>
                    </span>
                    <!-- End Header -->
                  </a>
                </div>
                <div id="catCollapseQuartier" class="collapse" aria-labelledby="catHeadingQuartier">
                  <div class="card-body p-0">


                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeBenevolat" class="custom-control-input"
                                     value="Benevolat"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeBenevolat">Bénévolat</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxePartenariartAsso" class="custom-control-input"
                                     value="Partenariat"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxePartenariartAsso">Partenariats associations</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                  </div>
                </div>

                <!-- 4 s'exprimer -->
                <div class="card-header card-collapse" id="catHeadingExprimer">
                  <a class="btn btn-link btn-sm btn-block card-btn" href="javascript:;" role="button"
                     data-toggle="collapse" data-target="#catCollapseExprimer"
                     aria-expanded="false" aria-controls="catCollapseExprimer">
                    <!-- Header -->
                    <span class="row">
                      <span class="col-8">
                        <span class="media">
                          <span class="card-btn-toggle mr-3 ml-0">
                            <span class="card-btn-toggle-default">+</span>
                            <span class="card-btn-toggle-active">−</span>
                          </span>
                          <span class="media-body">
                            <span class="text-body font-weight-bold mr-5">S'exprimer, Echanger, Agir</span>
                          </span>
                        </span>
                      </span>
                    </span>
                    <!-- End Header -->
                  </a>
                </div>
                <div id="catCollapseExprimer" class="collapse" aria-labelledby="catHeadingExprimer">
                  <div class="card-body p-0">


                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeCafe" class="custom-control-input" value="Cafe"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1"
                                     for="customAxeCafe">Café du citoyen</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeCulture" class="custom-control-input" value="Culture"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1"
                                     for="customAxeCulture">Actions culturelles</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeEmancipation" class="custom-control-input"
                                     value="Emancipation"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeEmancipation">Émancipation des femmes</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeEcologie" class="custom-control-input"
                                     value="Ecologie"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeEcologie">Questions d'écologie</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->


                  </div>
                </div>

                <!-- 5 sortir -->
                <div class="card-header card-collapse" id="catHeadingSortir">
                  <a class="btn btn-link btn-sm btn-block card-btn" href="javascript:;" role="button"
                     data-toggle="collapse" data-target="#catCollapseSortir"
                     aria-expanded="false" aria-controls="catCollapseSortir">
                    <!-- Header -->
                    <span class="row">
                      <span class="col-8">
                        <span class="media">
                          <span class="card-btn-toggle mr-3 ml-0">
                            <span class="card-btn-toggle-default">+</span>
                            <span class="card-btn-toggle-active">−</span>
                          </span>
                          <span class="media-body">
                            <span class="text-body font-weight-bold mr-5">Sortir ensemble</span>
                          </span>
                        </span>
                      </span>
                    </span>
                    <!-- End Header -->
                  </a>
                </div>
                <div id="catCollapseSortir" class="collapse" aria-labelledby="catHeadingSortir">
                  <div class="card-body p-0">


                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeCine" class="custom-control-input" value="Cine"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeCine">Ciné goûter</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeMusee" class="custom-control-input" value="Musee"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeMusee">Sorties collectives au musée</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeSpectacle" class="custom-control-input"
                                     value="Spectacle"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeSpectacle">Spectacles rencontres</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeVacances" class="custom-control-input"
                                     value="Vacances"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1"
                                     for="customAxeVacances">Vacances pour tous</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->

                    <!-- Course Program -->
                    <div class="border-bottom pt-1 px-2">
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="customAxeBonPlans" class="custom-control-input"
                                     value="Bon plans"
                                     v-model="checked_filters">
                              <label class="custom-control-label font-size-1" for="customAxeBonPlans">Bons plans</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- End Course Program -->


                  </div>
                </div>

              </div>
              <!-- End Card -->


            </div>
              <!-- End Collapse Categorie -->


            </span>
            <!-- Fin Thèmes -->

            <span>Filtres : {{ checked_filters }}</span>

          </div>
          <!-- Fin Filtres -->

          <!-- 2 Présentation des projets -->
          <div class="col-6 mx-2 sb-700 pr-3">

            <!-- Projet -->
            <article v-for="event in displayed_events" :key="event.id" class="row mb-7">

              <div class="col-md-4 ">
                <img :src="event.photo_url" class="w-80 mx-auto d-block">
              </div>
              <div class="col">
                <div class="card-body d-flex flex-column h-100 px-0 py-1">
                              <span class="d-block mb-2">
                                <h3><a class="font-weight-bold" href="#" data-toggle="tooltip" data-placement="top"
                                       title="Voir la fiche complète">{{ event.event_name }}</a></h3>
                              </span>
                  <span class="font-weight-bold mb-1" v-html="event.event_description">
                              </span>

                  <a href="#"><p class="text-muted d-inline-block" data-toggle="tooltip" data-placement="top"
                                 title="Voir sur la carte"><i class="fa fa-map-marker"></i>
                    {{ event.place.place_address }}</p></a>
                  <a class="d-inline-flex" href="#"><p class="text-success font-weight-bold d-inline-block"
                                                       data-toggle="tooltip" data-placement="top"
                                                       title="Je m'inscris à cette activité"><i
                      class="fa fa-calendar"></i> Inscription à partir du {{ event.event_start_date }}</p></a>
                  <p class="card-footer p-2">
                  <div class="row">
                    <div class="=col text-left">

                      <a href="#"><i class="fa fa-users mx-1" data-toggle="tooltip" data-placement="top"
                                     title="Accéder au groupe"></i></a>
                      <a href="#"><i class="fa fa-thumbs-up mx-1" data-toggle="tooltip" data-placement="top"
                                     title="J'aime"></i></a>
                      <a href="#"><i class="fa fa-location-arrow mx-1" data-toggle="tooltip" data-placement="top"
                                     title="Comment m'y rendre"></i></a>
                      <a href="#"><i class="fa fa-share mx-1" data-toggle="tooltip" data-placement="top"
                                     title="Partager"></i></a>
                      <a href="#"><i class="fa fa-star" data-toggle="tooltip" data-placement="top"
                                     title="Ajouter à mes favoris"></i></a></div>

                    <div class="col text-right">
                      <a href="#"><i class="fa fa-user text-secondary" data-toggle="tooltip" data-placement="top"
                                     title="Bénévoles"></i></a>
                      <a href="#"><i class="fa fa-tools text-secondary mx-1" data-toggle="tooltip" data-placement="top"
                                     title="Matériel"></i></a>
                      <a href="#"><i class="fa fa-warehouse text-secondary mx-1" data-toggle="tooltip"
                                     data-placement="top" title="Locaux"></i></a>
                      <a href="#"><i class="fa fa-brain text-secondary mx-1" data-toggle="tooltip" data-placement="top"
                                     title="Expertise"></i></a>
                      <a href="#"><i class="fa fa-euro-sign text-secondary mx-1" data-toggle="tooltip"
                                     data-placement="top" title="Finances"></i></a>

                    </div>

                  </div>

                </div>
              </div>
            </article>
            <!-- Fin Projet -->

          </div>
          <!-- Fin Présentation des projets -->


          <!-- 3 Map -->
          <div class="col">

            <l-map style="height: 500px" :zoom="zoom" :center="center">
              <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
              <l-marker v-for="event in events"
                        v-if="event.place.place_latitude != null && event.place.place_longitude != null"
                        :lat-lng="[event.place.place_latitude, event.place.place_longitude]" :key="event.id"
                        :icon="marker_icon">
                <l-tooltip>{{ event.event_name }}</l-tooltip>
                <l-popup>
                  <div>
                    {{ event.projet_nom }} ({{ event.nom }})
                    <p class="text-center">
                      <a class="btn btn-primary text-white"
                         :href="'/module/dlnkaap/page_vitrine_short?aap_id=' + event.id">
                        En savoir plus
                      </a>
                    </p>
                    <p>
                      {{ event.presentation }}
                    </p>
                  </div>
                </l-popup>
                <!--                        @click="marker_click(aap.id)">-->
                <!--                <l-popup> {{ open_popup(aap.id) }}</l-popup>-->
              </l-marker>

            </l-map>

          </div>
          <!-- Fin Map -->
        </div>

        <!-- Pagination -->

        <!-- Fin Pagination -->
      </article>
      <!-- End Tableau de navigation -->

    </div>
    <!-- End Navigation -->
  </main>
</template>

<script>

import {LMap, LTileLayer, LMarker, LTooltip, LPopup} from "vue2-leaflet";

export default {
  // name: "Example",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPopup,
  },

  data() {

    return {
      displayed_events: Array,
      wait_data: Boolean,


      events: Array,
      checked_filters: [],


      customer: Object,

      events_count: Number,
      events_page_count: Number,
      query: "",
      show_detail: Boolean,
      checked_thematiques: [],
      expanded: false,
      currentSelect: "",

      marker_icon: L.icon({
        iconUrl: "/themes/template/img/map/marker-icon-blue.png",
        iconSize: [20, 30],
        iconAnchor: [10, 30],
        popupAnchor: [0, -30],
      }),


      zoom: 12,
      initial_zoom: 12,
      center: ["48.9209964", "2.1158319"],
      initial_center: ["48.9209964", "2.1158319"],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5
      },
    };
  },
  mounted() {
    this.events = this.get_data()

  },
  methods: {

    get_data: function () {
      this.get_events()

    },

    get_events: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "events.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer
      axios.get(api_url)
          .then(function (response) {
            _this.events = response.data
            console.log(events)
          })
          .catch(function (error) {
            console.log(error)
            console.log(api_url)
          })
          .then(function () {
            _this.displayed_events = _this.events
          });
    },
  },
  computed: {}
}
</script>